import React from 'react';

const DatePickerResponse = ({ question, response, onUpdate }) => {
    const { config } = question;
    const value = response?.value || '';

    const handleChange = (e) => {
        onUpdate(question.id, e.target.value);
    };

    return (
        <div>
            <input
                type="date"
                className="form-control form-control-lg"
                value={value}
                onChange={handleChange}
                min={config?.minDate || undefined}
                max={config?.maxDate || undefined}
                placeholder="Select date"
                style={{
                    maxWidth: '300px'
                }}
            />
        </div>
    );
};

export default DatePickerResponse;
